import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import ReadOnlyTextarea from '../../../../CSIComponents/ReadOnlyTextarea';
import DetailItem from '../../../../CSIComponents/DetailItem';
interface propsTypes {
    //isEditable: void | any,
    cancelEditable: void | any,
    cancellationDetails: void | any,
    toggleToEditMode: void | any,
    setActiveTabKey: void | any
}
const PenaltyDetail = (props: propsTypes) => {
    const [detailData, setDetailData] = useState<{ label?: string, value?: string, span: number }[]>([]);
    const AMOUNT = 'Amount';
    const PERCENT = 'Percent';
    const NIGHTS = 'Nights';

    const _detailData = [
        { label: 'Charge Type', value: props?.cancellationDetails?.chargetype, span: 6 },
        { span: 6 },
        { span: 6 },
        { label: 'Description', value: props?.cancellationDetails?.description, span: 18 },
        { span: 6 },
        { label: 'Tax Inclusive', value: props?.cancellationDetails?.taxinclusive === 'true' ? 'Yes' : (props?.cancellationDetails?.taxinclusive === 'false' ? 'No' : ''), span: 6 },
        { label: 'Fee Inclusive', value: props?.cancellationDetails?.feeinclusive === 'true' ? 'Yes' : (props?.cancellationDetails?.feeinclusive === 'false' ? 'No' : ''), span: 6 },
    ]


    useEffect(() => {
        if (props?.cancellationDetails?.chargetype === AMOUNT) {
            _detailData[1] = { label: 'Charge (Amount)', value: props?.cancellationDetails?.chargeamount, span: 6 }
            _detailData[2] = { label: 'Currency', value: props?.cancellationDetails?.currency, span: 6 }
        } else if (props?.cancellationDetails?.chargetype === PERCENT) {
            _detailData[1] = { label: 'Charge (Percent)', value: props?.cancellationDetails?.chargepercent, span: 6 }
        } else if (props?.cancellationDetails?.chargetype === NIGHTS) {
            _detailData[1] = { label: 'Charge (Night)', value: props?.cancellationDetails?.chargenights, span: 6 }
        }
        setDetailData(_detailData)
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])


    const edit = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.setActiveTabKey('Cancellation') }}>Back</Button>
                    </div>
                    <div>
                        <Button type="primary" className="db-edit-btn" onClick={props.toggleToEditMode}>Edit</Button>
                    </div>
                </div>
    } 

    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }} title={props.cancellationDetails?.policycode} extra={edit()}>
                <div style={{ padding: "0 20px" }}>

                    <Row gutter={24}>
                        {detailData.length !== 0 && detailData.map((item, i) => {
                            return (
                                <React.Fragment key={i}>
                                    {
                                        item.label ? <>
                                            {
                                                item.label === 'Description' ?
                                                    <Col span={item.span} key={i} className="col-margin">
                                                        <ReadOnlyTextarea value={item.value} label={item.label} />
                                                    </Col> : <Col span={item.span} key={i} className="col-margin">
                                                        <DetailItem value={item.value} label={item.label} style={{}} />
                                                    </Col>}
                                        </> : <Col span={item.span} key={i}></Col>
                                    }
                                </React.Fragment>
                            )
                        })
                        }
                    </Row>
                </div>
            </Card>
        </PageContainer>
    )
}

export default PenaltyDetail;

